// Components
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

// Styles
import styles from './index.module.sass';
import { styled } from '@mui/material/styles';

const date = new Date();

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#002747',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 100,
    backgroundColor: '#002747',
  },
});

type Props = {
  node: Object,
  getOrder: Function,
  device: Object,
};
//BORRARPRO
export default function OrderTable({ node, getOrder, device, t }: Props): React$Node {
  const {
    imagen = '',
    clave = '',
    descri = '',
    cantidad = '',
    letra = '',
    precio = '',
    importe = '',
    status = '',
    agrupador = '',
  } = node;

  const screenSize = device?.screenSize || 'desktop';

  return (
    <div className={`${styles.container} ${styles[screenSize]} ${status !== '' && styles.alert}`}>
      <div className={styles.image}>
        <img src={`${imagen}?x=${date.getFullYear()}${date.getMonth() + 1}`} alt={descri} />
      </div>
      <div className={`${styles.column} ${styles.product}`}>
        <div className={styles.name}>
          <label className={styles.idname}>
            <label className={styles.id}>{clave}</label> - {descri}
            {agrupador === 'COMPONENTES' && <label> ({t('isComponent')})</label>}
          </label>
        </div>
      </div>
      <div className={`${styles.column}`}>{cantidad}</div>
      <div className={`${styles.column}`}>{letra}</div>
      <div className={`${styles.column}`}>${precio}</div>
      <div className={`${styles.column}`}>${importe}</div>
      <div className={`${styles.column}`}>
        {status !== '' && (
          <CustomWidthTooltip title={status} placement='right' arrow>
            {<span className={`material-icons-outlined ${styles.tooltip}`}>report_problem</span>}
          </CustomWidthTooltip>
        )}
      </div>
    </div>
  );
}
